import { MultipleSupplierScores } from "./Scores/MultipleSupplierScores";
import { useIngredientContext } from "./useIngredientContext";
import { OneSupplierScore, NoSupplierScore } from "./Scores/OneOrNoSupplierScore";
import { useEntityScores } from "src/context/Scores/useEntityScores";
import { NoScoresAvailableMessage } from "src/components/Message/NoScoresAvailableMessage";
import { Loading } from "src/components/utils/Loading";
import { Fragment } from "react";
import { ExtensionPoint, EXTENSION_POINTS } from "src/components/PuckExtensions";
import { getNumberOfSuppliers } from "./getNumberOfSuppliers";
import { useIsProductUxV2 } from "src/hooks/useIsProductUxV2";
import { useCompanyMetadata } from "src/context/Company/Metadata/useCompanyMetadata";
import { selectIngredientScoresView } from "./selectIngredientScoresView";

export const IngredientScores = () => {
    const { ingredient, isReady, showIngredientSuppliers } = useIngredientContext();
    const { scoresWithVariations } = useEntityScores();
    const { company } = useCompanyMetadata();
    const isProductUxV2 = useIsProductUxV2();
    const appearance = isProductUxV2 ? "product-v2" : "legacy";

    if (isReady === false) {
        return <Loading appearance={appearance} />;
    }

    if (ingredient === undefined) {
        // Since it's ready above, here, error message;
        return null;
    }

    if (!scoresWithVariations.length) return <NoScoresAvailableMessage appearance={appearance} />;

    const view = selectIngredientScoresView({
        showIngredientSuppliers,
        visibleSuppliersCount: getNumberOfSuppliers(ingredient.suppliers),
        isIngredientOwner: ingredient.ownedBy?.id === company.id,
    });

    const content =
        view === "none" ? <NoSupplierScore />
        : view === "one" ? <OneSupplierScore />
        : <MultipleSupplierScores />;

    return (
        <Fragment>
            <ExtensionPoint extensionPoint={EXTENSION_POINTS.INGREDIENT_DETAIL_SCORE_HEADER} />
            {content}
            <ExtensionPoint extensionPoint={EXTENSION_POINTS.INGREDIENT_DETAIL_SCORE_FOOTER} />
        </Fragment>
    );
};
